/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCulture
 */
export interface MelcoModelsCulture {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCulture
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCulture
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCulture
     */
    short_code: string;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCulture
     */
    name: string;
}

export function MelcoModelsCultureFromJSON(json: any): MelcoModelsCulture {
    return MelcoModelsCultureFromJSONTyped(json, false);
}

export function MelcoModelsCultureFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCulture {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'short_code': json['short_code'],
        'name': json['name'],
    };
}

export function MelcoModelsCultureToJSON(value?: MelcoModelsCulture | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'short_code': value.short_code,
        'name': value.name,
    };
}


